import { Injectable } from '@angular/core';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
 
@Injectable()
export class StorageService {

  constructor(
    //public local: LocalStorageService
  ) { }

  getItem( name:string){
    return window.localStorage.getItem(name);
  }
  setItem(name:string,value:any,expiratedAt?:number ){
    window.localStorage.setItem(name,value)
  }
  removeItem(name:string){
    window.localStorage.remove(name);
  
  }
  clear(){
    window.localStorage.clear();
  }

}

@Injectable()
export class SessionService {

  constructor(
  //  public local: SessionStorageService
  ) { }

  getItem( name:string){
    return window.localStorage.get(name);
  }
  setItem(name:string,value:any,expiratedAt?:number ){
    window.localStorage.set(name,value,expiratedAt)
  }
  removeItem(name:string){
    window.localStorage.remove(name);
  }
  clear(){
    window.localStorage.clear();
  }


}
